import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { paths } from '@platform/paths';
import { ModalContainerComponent } from '@shared-lib/components/modal-container/modal-container.component';
import { ButtonDirective } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { selectIsExperianCompany } from '../../store/common.selectors';

@Component({
  selector: 'cp-cookie-consent-dialog',
  imports: [CommonModule, ButtonDirective, ModalContainerComponent, RouterLink],
  templateUrl: './cookie-consent-dialog.component.html',
  styleUrl: './cookie-consent-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('growShrink', [
      state(
        'hidden',
        style({
          height: '0',
          opacity: 0,
          overflow: 'hidden',
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: 0,
          marginBottom: 0,
        }),
      ),
      state(
        'visible',
        style({
          height: '*',
          opacity: 1,
        }),
      ),
      transition('hidden <=> visible', [animate('0.4s ease-in-out')]),
    ]),
  ],
})
export class CookieConsentDialogComponent implements AfterViewInit {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly dynamicDialogRef = inject(DynamicDialogRef);
  private readonly globalStore = inject(Store);

  protected readonly paths = paths;

  protected readonly isExperianCompany$ = this.globalStore.select(selectIsExperianCompany);

  protected isDialogPositionUp = false;
  protected showDetails = false;

  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      this.isDialogPositionUp = true;
      this.changeDetectorRef.markForCheck();
    });
  }

  agree(): void {
    this.dynamicDialogRef.close(true);
  }

  disagree(): void {
    this.dynamicDialogRef.close(false);
  }

  setShowDetails(value: boolean): void {
    this.showDetails = value;
  }
}
